module.exports = __webpack_public_path__ + "static/media/wmsui32_2221.1695e915.ico";